module.exports = __webpack_public_path__ + "static/img/0EF703BA-AAE5-4e21-BDC5-A3DD49D21A97.a3a6eeda.png";